import {
  useEffect, useMemo,
} from 'react';
import { convertColorToWebGLColor } from '~/_shared/utils/colors/colors.helpers';
import {
  getSingleZIndex, ZIndexedEntity,
} from '~/map/zIndexes/zIndexRanges';
import type { BoundingBox } from '../boundingBox';
import { useMapContext } from '../mapContext';

export const PlacesSearchRectangleOverlayContainer = ({
  boundingBox,
  color,
}: {
  boundingBox: BoundingBox;
  color: string;
}) => {
  const { webglLayers } = useMapContext();
  const zIndex = getSingleZIndex(ZIndexedEntity.PlacesAreaHighlight);

  const points = useMemo(() => ([
    boundingBox.getNorthEast(),
    {
      lat: boundingBox.getSouthWest().lat,
      lng: boundingBox.getNorthEast().lng,
    },
    boundingBox.getSouthWest(),
    {
      lat: boundingBox.getNorthEast().lat,
      lng: boundingBox.getSouthWest().lng,
    },
    boundingBox.getNorthEast(),
    // extra point to render a closed corner
    {
      lat: boundingBox.getSouthWest().lat,
      lng: boundingBox.getNorthEast().lng,
    },
  ]), [boundingBox]);

  useEffect(() => {
    const polyline = new WebGLOverlay.Polyline({
      zIndex,
      width: 3,
      color: convertColorToWebGLColor(color),
      stroke: false,
    }, points);

    webglLayers.MapObjectPolylines.add(polyline);

    return () => {
      webglLayers.MapObjectPolylines.remove(polyline);
    };
  }, [color, points, webglLayers.MapObjectPolylines, zIndex]);

  return null;
};
